import React, { useState } from "react"
import Message from "./Message"
import { updateTime } from "./UpdateTime"

const ExpandableText = ({ text, descriptionLength, NotificationType }) => {
  const fullText = text.anntext
  const [isExpanded, setIsExpanded] = useState(false)
  const toggleText = () => setIsExpanded(!isExpanded)

  // console.log(text.type_label)
  const shouldShowReadMore = fullText.length > descriptionLength

  const notificationTypes = {
    1: "Homework",
    2: "Announcement",
    3: "Student Specific",
    // 12: "Message"
  }

  return (
    <>
      <div style={{ fontSize: "15px" }} className="text-dark">
        <Message
          text={isExpanded ? fullText : fullText.slice(0, descriptionLength)}
        />
        {!isExpanded && shouldShowReadMore && (
          <span
            className="text-primary d-block mb-0 pb-0 fw-semibold"
            onClick={toggleText}
          >
            <b>... Read more</b>
          </span>
        )}
      </div>
      <div className="w-100 p-0 m-0">
        <span className="metadata">
          <div className="d-flex flex-column">
            <span className="fw-medium text-dark small">
              {text.stud_name || ""}
            </span>
            <span className="fw-medium text-dark small">
              {text.div_name || ""}
            </span>
            <span className="fw-medium text-dark small">
              {notificationTypes[NotificationType] || text.type_label || ""}
            </span>
          </div>

          <span className="time"> {updateTime(text.created)}</span>
        </span>
      </div>
    </>
  )
}

export default ExpandableText;